import { NavLink, useRouteMatch } from 'react-router-dom';
import { t } from '@base/utils/helpers';
import { ReactComponent as Help } from '@base/assets/images/faq.svg';
import styles from '../styles/helpMenuPanel.module.scss';
import { Routes } from '../constants/routes';

function HelpMenuPanel(props: {children: string[]}) {
  const { url } = useRouteMatch();

  return (
    <div className={styles.menu}>
      <div className={styles.avatar}>
        <Help />
      </div>
      <h1>{t('help')}</h1>
      <nav>
          <NavLink
            activeClassName={styles.active}
            to={url + '/' + Routes.HOW_TO_START_PLAYING}
          >
            {t(Routes.HOW_TO_START_PLAYING)}
          </NavLink>
          {props.children.map((key) => (
            <NavLink
              key={key}
              activeClassName={styles.active}
              to={url + '/' + key}
            >
              {t(key)}
            </NavLink>
          ))}
          <NavLink
            activeClassName={styles.active}
            to={url + '/' + Routes.FAQ}
          >
            {t(Routes.FAQ)}
          </NavLink>
      </nav>
    </div>
  );
}

export default HelpMenuPanel;
